import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Factory, Wheat, Wrench, Sparkles } from 'lucide-react';
import type { BusinessSummary } from '../hooks';
import { BusinessCooldownTimer } from './BusinessCooldownTimer';

const BUSINESS_ICONS: Record<string, React.ReactNode> = {
  mining: <Factory className="h-5 w-5" />,
  farming: <Wheat className="h-5 w-5" />,
  equipment: <Wrench className="h-5 w-5" />,
  effician: <Sparkles className="h-5 w-5" />,
};

const BUSINESS_COLORS: Record<string, string> = {
  mining: 'text-orange-500',
  farming: 'text-green-500',
  equipment: 'text-blue-500',
  effician: 'text-purple-500',
};

interface BusinessCardProps {
  business: BusinessSummary;
}

export function BusinessCard({ business }: BusinessCardProps) {
  return (
    <Link to={`/a/arche_businesses/${business.businessId}`}>
      <Card className="hover:border-primary/50 transition-colors cursor-pointer">
        <CardHeader className="pb-2">
          <div className="flex items-center justify-between">
            <CardTitle className="text-base flex items-center gap-2">
              <span className={BUSINESS_COLORS[business.businessType]}>
                {BUSINESS_ICONS[business.businessType]}
              </span>
              {business.name}
            </CardTitle>
            <Badge variant="outline" className="capitalize">
              {business.businessType}
            </Badge>
          </div>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-between text-sm text-muted-foreground">
            <span>Level {business.level}</span>
            <BusinessCooldownTimer
              cooldownRemaining={business.cooldownRemaining}
              canCollect={business.canCollect}
            />
          </div>
          <div className="mt-1 text-xs text-muted-foreground">
            {business.dailyCollectionsUsed}/3 collections today
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
